<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/repair/stroe"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" @click="handleRow(row, 'edit')">编辑</el-button>
          <el-button type="text" size="mini" @click="handleRow(row, 'del')">删除</el-button>
        </template>
      </BaseTable>
            <!-- 修改 -->
        <el-drawer title="修理厂" size="50%" :visible.sync="isShowDrawer" direction="rtl">
          <!-- <BaseDialog :visible.sync="isShowDrawer" title="服务条款" @confirm="onSubmit"  width = "50%"> -->
              <div style="padding: 30px;">
                <div style="flex"></div>
                <el-form labelWidth="100px" size="medium">
                  <el-form-item class="from-item--30" label="维修厂资质" prop="claims_type">
                    <el-select v-model="formData.qualification" filterable>
                      <el-option label="一类修理厂" value="1"></el-option>
                      <el-option label="二类修理厂" value="2"></el-option>
                      <el-option label="三类修理厂" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="名称">
                    <el-input  v-model="formData.name" required></el-input>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="照片" prop="storePhoto" >
                    <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
                      list-type="picture-card" :file-list="storePhoto" :limit="5"
                      :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file)"
                      :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList)
                        ">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="联系电话">
                    <el-input v-model="formData.phone" required></el-input>
                  </el-form-item>
                  <el-form-item label="产品服务">
                    <el-input v-model="formData.service_scope" required></el-input>
                  </el-form-item>
                  <el-form-item label="选择地址">
                    <el-button @click="openMapDialog">选择位置</el-button>
                        <el-dialog title="地图选点" :visible.sync="dialogVisible" width="70%">
                          <iframe 
                            width="100%" 
                            height="500px" 
                            :src="mapUrl"
                          ></iframe>
                        </el-dialog>
                  </el-form-item>
                  <el-form-item label="详细地址">
                    <el-input v-model="formData.address" required></el-input>
                  </el-form-item>
                  <el-form-item label="经度">
                    <el-input v-model="formData.longitude" :disabled="true" required></el-input>
                  </el-form-item>
                  <el-form-item label="维度">
                    <el-input v-model="formData.latitude" :disabled="true" required></el-input>
                  </el-form-item>
                  <el-form-item label="详情">
                    <el-input type="textarea" v-model="formData.content" required></el-input>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="状态" prop="claims_type">
                    <el-select v-model="formData.status" filterable>
                      <el-option label="禁用" value="1"></el-option>
                      <el-option label="启用" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="from-item--30" label="是否推荐" prop="claims_type">
                    <el-select v-model="formData.is_recommend" filterable>
                      <el-option label="推荐" value="1"></el-option>
                      <el-option label="不推荐" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form>
              </div>
        </el-drawer>
        <el-dialog :visible.sync="preVisible">
          <img width="100%" :src="preImageUrl" alt="" />
        </el-dialog>
        <!-- </BaseDialog> -->
    </div>
  </div>
</template>
<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Repairshop",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      isShowDrawer:false,
      formData:{
        qualification:'',
        name:'',
        phone:'',
        address:'',
        latitude:'',
        longitude:'',
        content:'',
        status:'',
        is_recommend:'',
      },
      storePhoto:[],
      dialogVisible: false,
      // 替换为你的腾讯地图开发者key
      mapKey: 'BAPBZ-GXGCL-WGRP5-EEZWO-VUVCH-E4BGX',
      mapUrl: '',
      id:0,
      preVisible: false,
      preImageUrl: "",
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    
  },
  methods: {
    openMapDialog() {
      this.mapUrl = `https://mapapi.qq.com/web/mapComponents/locationPicker/v/index.html?search=1&type=1&key=${this.mapKey}&referer=location`
      this.dialogVisible = true
      // 添加消息监听
      window.addEventListener('message', this.handleMapMessage, false)
    },
    
    handleMapMessage(event) {
      const loc = event.data
      if (loc && loc.module === 'locationPicker') {
        this.formData.address = loc.poiaddress;
        this.formData.latitude = loc.latlng.lat;
        this.formData.longitude = loc.latlng.lng;
        this.dialogVisible = false
        window.removeEventListener('message', this.handleMapMessage)
      }
    },
    
    // 图片上传之前
    handlePictureCardPreview(file) {
        this.preImageUrl = file.url;
        this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList) {
        this.storePhoto = this.storePhoto.filter((el) => el.url !== res.url);
    },

    async handleChangeFile(file) {
      this.loading = true;
      const fd = new FormData();
      fd.append("img", file.raw);
      fd.append("path", "20");
      console.log(fd)
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this.storePhoto.push({
          imageType: 1,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    async onSubmit(){
      if(this.formData.qualification == '' || !this.formData.qualification){
        this.$message.warning("请选择维修厂资质");
        return;
      }
      if(this.formData.name == '' || !this.formData.name){
        this.$message.warning("名称不能为空");
        return;
      }
      if(this.storePhoto == '' || !this.storePhoto){
        this.$message.warning("请上传照片");
        return;
      }
      if(this.formData.phone == '' || !this.formData.phone){
        this.$message.warning("联系电话不能为空");
        return;
      }
      if(this.formData.service_scope == '' || !this.formData.service_scope){
        this.$message.warning("产品服务不能为空");
        return;
      }
      if(this.formData.address == '' || !this.formData.address){
        this.$message.warning("详细地址不能为空");
        return;
      }
      if(this.formData.longitude == '' || !this.formData.longitude){
        this.$message.warning("请选择位置");
        return;
      }
      if(this.formData.content == '' || !this.formData.content){
        this.$message.warning("详情不能为空");
        return;
      }
      if(this.formData.status == '' || !this.formData.status){
        this.$message.warning("请选择状态");
        return;
      }
      if(this.formData.is_recommend == '' || !this.formData.is_recommend){
        this.$message.warning("请选择是否推荐");
        return;
      }
      this.formData.storePhoto = [
        ...this.storePhoto,
      ];
      let query = await this.$api.post(
        "/admin/repair/stroesave",
        { ...this.formData , id: this.id || 0},
      );
      if(query.code == 10000){
        this.isShowDrawer = false;
        this.handleSearch();
        this.id = 0
      }
    },
    // 打开新增退统弹窗
    add() {
      this.id = 0
      this.storePhoto = [];
      this.formData = {};
      this.isShowDrawer = true;
    },
    handleRow(row, k) {
      switch (k) {
        case "edit":
          this.handleEdit(row);
          break;
        case "del":
          this.handleDel(row);
          break;
        default:
          break;
        }
    },
    // 点击编辑
    async handleEdit({ id }) {
      this.id = id
      const res = await this.$api.post("/admin/repair/getStoreDetails", {
        id: id,
      });
      this.formData = res.data.data;
      this.storePhoto = res.data.storePhoto;
      this.isShowDrawer = true;
    },
   // 点击删除
   handleDel({ id }) {
      this.$confirm(`是否确认删除【ID${id}】修理厂, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/repair/stroedel",
            { id: id },
            "删除"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>

<style scoped>
.el-drawer{
  width: 50%;
}
</style>